import L from "leaflet";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine";

import './Routing.css';

import { createControlComponent } from "@react-leaflet/core";
import "leaflet-routing-machine";
import { GreenIcon } from "./mapData";

// L.Marker.prototype.options.icon = L.icon({
//   iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png"
// });

//L.Marker.prototype.options.icon = GreenIcon
L.Marker.prototype.options.icon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [0, 0],
  //iconAnchor: [12, 41],
  //popupAnchor: [1, -34],
  shadowSize: [0, 0]
});

interface RoutingProps {
  //page: IPageState,
  map: any,
  latRestaurant: number, 
  lngRestaurant: number, 
  latClient: number, 
  lngClient: number, 
}

const createRoutineMachineLayer = (props: RoutingProps) => {
  const instance = L.Routing.control({
    waypoints: [
      L.latLng(props.latRestaurant, props.lngRestaurant),
      L.latLng(props.latClient, props.lngClient),
    ],
    // @ts-ignore
    lineOptions: {
      styles: [
        {
          color: "green",
          opacity: 1, //0.6,
          weight: 4,
          fillColor: "green",
        }
      ]
    },
    pointMarkerStyle: {
      //className: "markerIcon",
      color: "green",
      fillColor: "green",
      radius: 8


    },
    //addWaypoints: true,
    addWaypoints: false,
    draggableWaypoints: false,
    //fitSelectedRoutes: false,
    //showAlternatives: false
  });

  return instance;
};
// @ts-ignore
const RoutingMachine = createControlComponent(createRoutineMachineLayer);

export default RoutingMachine;